module.exports = __webpack_public_path__ + "static/media/person-dark.5259a7c3.svg";